import ResultsTable from "../components/ResultsTable";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet-async";

export default function Course(props) {
  return (
      <>
      <Helmet>
      <title>My Results - KnowledgEquity</title>
      </Helmet>
      <Grid sx={{ padding: "20px", background: "#f2f2f2" }}>
        <ResultsTable />
      </Grid>
    </>
  );
}
